import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { authInterceptor } from './shared/auth.interceptor';
import { AuthService } from './services/auth-service.service';


export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideClientHydration(),
    provideHttpClient(withInterceptors([
      authInterceptor
    ])),
    importProvidersFrom(CommonModule),
    AuthService
  ],
};

export const apiConfiguration = {
  urlAuth: [
    "v1/order-status-web-all",
    "v1/web/otp/internalOrdernumberMax",
    "v1/web/otp/externalOrdernumberMax",
    "v1/tracking/getLastCoordinate"
  ],
  pageSize: 50
};

export const mabeSettings = {
  itemsPerPage: 3,

}


